import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-avatar-stack',
  imports: [CommonModule],
  templateUrl: './avatar-stack.html',
  styleUrl: './avatar-stack.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarStack {
@Input() avatarArray : any
}
